import { ComponentWithAs, Flex, IconProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { IconTab } from "./icon-tab";

export interface IconTab_T {
  icon: ComponentWithAs<"svg", IconProps> | any;
  label: string;
  href: string;
}
export interface PremiumSidebarProps extends PropsWithChildren<{}> {
  tabs: IconTab_T[];
  pathname: string;
}

export const PremiumSidebar = (props: PremiumSidebarProps) => {
  const { tabs, pathname, children } = props;
  return (
    <Flex
      height={{ base: "auto", lg: "100%" }}
      position="fixed"
      bottom="0"
      right="0"
      left="0"
      direction={{ base: "row", lg: "column" }}
      bg="blue.500"
      width={{ base: "full", lg: "20" }}
      align="center"
      justify="flex-start"
      gap={{ base: "0", lg: "6" }}
      pt={{ base: "0", lg: "28" }}
      zIndex="1"
      className="sidebar"
    >
      {tabs.map((tabProps, idx) => {
        return <IconTab key={idx} pathname={pathname} {...tabProps} />;
      })}
      <Flex
        py={{ base: "0", lg: "6" }}
        direction="column"
        flex="1"
        alignItems="center"
        justify="flex-end"
      >
        {children}
      </Flex>
    </Flex>
  );
};
